var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReviewDone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAE9E1",
    stroke: "#F07735",
    strokeWidth: 2,
    d: "M18.28 18.28C29.346 7.217 44.353 1 60 1s30.655 6.216 41.719 17.28C112.784 29.346 119 44.353 119 60s-6.216 30.655-17.281 41.719C90.655 112.784 75.648 119 60 119s-30.655-6.216-41.72-17.281C7.217 90.655 1 75.648 1 60s6.216-30.655 17.28-41.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF9F6",
    d: "M60 21.632c-10.176 0-19.935 4.042-27.13 11.237C25.674 40.065 21.632 49.824 21.632 60c0 10.176 4.042 19.935 11.238 27.13C40.065 94.327 49.824 98.369 60 98.369c10.176 0 19.935-4.042 27.13-11.237C94.327 79.935 98.37 70.176 98.37 60c0-10.176-4.043-19.935-11.238-27.13C79.935 25.673 70.176 21.631 60 21.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F28C54",
    d: "M60 99.474C38.21 99.474 20.526 81.79 20.526 60c0-21.79 17.685-39.474 39.474-39.474 21.79 0 39.474 17.685 39.474 39.474 0 21.79-17.684 39.474-39.474 39.474zm0-76.58c-20.526 0-37.105 16.58-37.105 37.106 0 20.526 16.579 37.105 37.105 37.105 20.526 0 37.105-16.579 37.105-37.105 0-20.526-16.579-37.105-37.105-37.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.842 27.947c-8.543 0-16.736 3.394-22.776 9.435-6.04 6.04-9.434 14.233-9.434 22.776s3.393 16.735 9.434 22.776c6.04 6.04 14.233 9.434 22.776 9.434s16.736-3.393 22.776-9.434c6.041-6.04 9.435-14.233 9.435-22.776s-3.394-16.736-9.435-22.776c-6.04-6.041-14.233-9.435-22.776-9.435z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F28C54",
    d: "M90.633 51.79c-.316 0-.632-.158-.79-.632l-.473-1.421C88.738 48 87.949 46.263 87 44.684c-.158-.316-.158-.79.316-1.105.316-.158.79-.158 1.105.316.948 1.737 1.737 3.473 2.369 5.21l.474 1.421c.157.474-.158.79-.474.948 0 .158 0 .316-.158.316z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F28C54",
    d: "M60.001 93c-18.158 0-33-14.684-33-32.842s14.842-32.842 33-32.842c9.474 0 18.474 4.105 24.632 11.052.473.474.947 1.106 1.42 1.58.316.315.159.789-.157 1.105-.316.315-.79.157-1.106-.158-.473-.474-.789-1.106-1.263-1.58-6-6.63-14.526-10.578-23.526-10.578C42.633 28.737 28.58 42.789 28.58 60c0 17.368 14.053 31.42 31.421 31.42s31.421-14.052 31.421-31.262c0-1.58-.158-3.158-.316-4.737 0-.474.158-.79.632-.947.474 0 .79.158.947.631.316 1.58.316 3.316.316 4.895 0 18.158-14.842 33-33 33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    d: "M58.21 70.895c-.557 0-1.002-.223-1.448-.557L47.4 60.975c-.892-.78-.892-2.117-.112-3.009.446-.446 1.003-.669 1.56-.669.558 0 1.004.223 1.45.558l7.913 8.024 13.374-13.374c.446-.335.892-.558 1.45-.558.556 0 1.114.223 1.56.67.334.445.557 1.002.557 1.56 0 .557-.223 1.114-.669 1.449l-14.712 14.6c-.446.446-1.003.669-1.56.669z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H120V120H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReviewDone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/review_done.f7af501a.svg";
export { ForwardRef as ReactComponent };